import { StreamLayerProvider } from '@lib/es'

import { Container } from '../styles'
import { type Channel } from '../app/ChannelsList'
import { VideoView } from './SimpleVideoView'
import { init } from '@noriginmedia/norigin-spatial-navigation'

declare global {
  interface Window {
    SL_PRODUCTION?: string
    SL_SDK_KEY?: string
    SL_EVENT_ID?: string
    SL_CHANNELS?: Channel[]
  }
}

const searchParams = new URLSearchParams(window.location.search)

const PRODUCTION =
  searchParams.get('production') === null
    ? (window.SL_PRODUCTION !== undefined && window.SL_PRODUCTION === 'true') || process.env.VITE_PRODUCTION === 'true'
    : searchParams.get('production') === 'true'

const SDK_KEY = searchParams.get('sdk_key') || window.SL_SDK_KEY || process.env.VITE_SDK_KEY || ''
const EVENT_ID = searchParams.get('event_id') || window.SL_EVENT_ID || process.env.VITE_EVENT_ID || ''

const channels: Channel[] = window.SL_CHANNELS || [
  {
    id: '1',
    name: 'Big Buck Bunny',
    videoStreamUrl:
      'https://storage.googleapis.com/cdn.streamlayer.io/assets/sdk-web/Own%20The%20Game%201080p%20RF18.mp4',
    thumbnail: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/BigBuckBunny.jpg',
    vastUrl:
      'https://pubads.g.doubleclick.net/gampad/ads?env=vp&gdfp_req=1&iu=/23213969138/adxvsporta&output=vast&sz=640x480|640x480&unviewed_position_start=1&url=com.streamlayer.sporta&description_url=http://streamlayer.io&correlator=[placeholder]&vpa=click&vpmute=0&npa=0&an=GURKN8N75N.com.streamlayer.sporta&rdid=[placeholder]&idtype=idfa&is_lat=[placeholder]&tfcd=0&vpos=preroll',

    duration: '09:56',
  },
  {
    id: '2',
    name: 'Sintel',
    videoStreamUrl:
      'https://storage.googleapis.com/cdn.streamlayer.io/assets/sdk-web/Own%20The%20Game%201080p%20RF18.mp4',
    thumbnail: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/Sintel.jpg',
    vastUrl:
      'https://pubads.g.doubleclick.net/gampad/live/ads?iu=/23213969138/adxvsporta&description_url=http%3A%2F%2Fstreamlayer.io&tfcd=0&npa=0&sz=640x480%7C640x480&gdfp_req=1&unviewed_position_start=1&correlator=[placeholder]&url=http%3A%2F%2Fstreamlayer.io&vpos=preroll&output=vast&env=vp&vpmute=1&vpa=auto&wta=1',
    duration: '14:48',
  },
]

// Initialize once at app startup (enables remote-control / keyboard navigation)
init({
  shouldFocusDOMNode: true,
})

function App() {
  return (
    <div className="app-container">
      <StreamLayerProvider sdkKey={SDK_KEY} production={PRODUCTION} event={EVENT_ID}>
        <Container>
          <VideoView channel={channels[0]} />
        </Container>
      </StreamLayerProvider>
    </div>
  )
}

export default App
